
export const Types = {
    SUBMIT_COPY_CHALLENGE: "SUBMIT_COPY_CHALLENGE",
    COPY_CHALLENGE_COMPLETE: "CREATE_COPY_COMPLETE",
    START_COPY_CHALLENGE: "START_COPY_CHALLENGE",
    END_COPY_CHALLENGE: "END_CREATE_COPY",
    ERROR_COPYING_CHALLENGE: "ERROR_COPYING_CHALLENGE"
};

export const submitCopyChallenge = (permalink, lang) => ({
    type: Types.SUBMIT_COPY_CHALLENGE,
    permalink: permalink,
    lang: lang
});

export const copyChallengeCompleted = (challengeId) => ({
    type: Types.COPY_CHALLENGE_COMPLETE,
    challengeId: challengeId
});

export const startCopyChallengeAction = (copyChallengeId, permalink) => ({
    type: Types.START_COPY_CHALLENGE,
    copyChallengeId: copyChallengeId,  // id of the challenge to copy
    permalink: permalink
});

export const endCopyChallengeAction = () => ({
    type: Types.END_COPY_CHALLENGE
});

export const errorCopyingChallengeAction = (error) => ({
    type: Types.ERROR_COPYING_CHALLENGE,
    error: error
});


// WEBPACK FOOTER //
// ./public/pages/BreakCopy/actions.js